import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar.component';
import { RouterModule } from '@angular/router';
import { NgOptimizedImage } from '@angular/common'
import { OverlayPanelModule } from 'primeng/overlaypanel';

@NgModule({
  declarations: [NavbarComponent],
  imports: [
    CommonModule,
    RouterModule,
    NgOptimizedImage,
    OverlayPanelModule
  ],
  exports: [
    NavbarComponent
  ]
})
export class NavbarModule { }
